module.exports = __webpack_public_path__ + "img/login-page-icon.634c339b.svg";